<template>
  <div class="pa-2">
    <FormTemplateFieldSelector
      :templateID="$route.params.id"
      v-if="!loading && fieldSelecting"
      @select="fieldSelecting = false;editparagraph.conditional_question_id = arguments[0].question_id; editparagraph.conditional_fieldtype_id = arguments[0].fieldtype_id"
      @cancel="fieldSelecting = false"
    />

    <div class="d-flex align-center justify-space-between mb-4" style="width: 100%;">
      <div class="text-h6 text-truncate" style="min-width: 0; flex-shrink: 1;">Paragraph Settings</div>
      <div class="d-flex align-center flex-shrink-0 ml-2">
        <v-btn small text dense @click="$emit('cancel')">Cancel</v-btn>
        <v-btn small color="info" @click="save" class="ml-2">Save</v-btn>
      </div>
    </div>

    <div style="position:relative;">
      <Preloader v-if="loading"/>
      <div class="text-subtitle-2 mb-2">Text Content</div>
      <Editor
        :enable_html="true"
        :enable_formatting='editparagraph.web_only'
        ref="htmlEditor"
        :html="editparagraph.text"
        @editingHTML="(val) => editHTML = val"
      />
    </div>

    <v-divider class="my-4" />

    <div class="text-subtitle-2 mb-2">Display Settings</div>
    <v-checkbox
      v-model="editparagraph.web_only"
      label="Hide on PDF (Web Only)"
      class="mt-0 mb-2"
    />
    <v-checkbox
      v-model="editparagraph.pdf_only"
      label="PDF Only"
      persistent-hint
      hint="Do not show on Web"
      class="mt-0 mb-4"
    />

    <v-divider class="my-4" />

    <div class="text-subtitle-2 mb-2">Conditional Visibility</div>
    <v-checkbox
      v-model="conditional_part"
      label="Conditional Form Part"
      persistent-hint
      hint="Display part depending on answer to question"
      class="mt-0 mb-4"
    />
    
    <div v-if="conditional_part" class="pl-3" style="border-left: 2px solid #eee;">
      <v-text-field
        v-model="editparagraph.conditional_question_id"
        label="Question ID"
        disabled
        class="mb-4"
      />
      <v-text-field
        v-model="editparagraph.conditional_fieldtype_id"
        label="Fieldtype ID"
        disabled
        class="mb-4"
      />
      <v-text-field
        v-model="editparagraph.conditional_value"
        label="Conditional Value"
        class="mb-4"
      />
      <v-checkbox
        v-model="editparagraph.conditional_apply_pdf"
        label="Apply to PDF"
        persistent-hint
        hint="Hide from PDF if part fails condition"
        class="mt-0 mb-4"
      />
      <v-btn
        small
        outlined
        @click="fieldSelecting = true"
        class="mb-4"
      >
        Select a field
      </v-btn>
    </div>

  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import Preloader from '@/components/global/Preloader'
import Editor from '@/components/admin/Editor'
import FormTemplateFieldSelector from '@/components/admin/FormTemplateFieldSelector'

export default {
  name: 'ParagraphProperties',
  props: [ 'partId', 'newPart' ],
  components: {
    Preloader,
    Editor,
    FormTemplateFieldSelector
  },
  data () {
    return {
      editparagraph: {},
      loading: false,
      displayAdditional: false,
      editHTML: false,
      conditional_part: false,
      fieldSelecting: false
    }
  },
  created () {
    this.editparagraph = JSON.parse(JSON.stringify(this.paragraph))
    this.conditional_part = (this.editparagraph.conditional_question_id)
  },
  computed: {
    ...mapGetters('formtemplate', [
      'partById',
    ]),
    paragraph: function () {
      return this.partById(this.partId) || this.newPart
    },
  },
  methods: {
    ...mapActions('formtemplate', [
      'saveParagraph'
    ]),
    save () {
      this.loading = true
      this.editparagraph.text = this.$refs.htmlEditor.getHTML()
      if(!this.conditional_part){
        this.editparagraph.conditional_question_id = null
        this.editparagraph.conditional_fieldtype_id = null
        this.editparagraph.conditional_apply_pdf = false
        this.editparagraph.conditional_value = ""
      }
      if (!this.editHTML){
        this.editparagraph.text = this.$refs.htmlEditor.getHTML().replace(/<p>/g, "").replace(/<\/p>/g, "<br>").replace(/(<br>*)$/,'')
      }
      this.saveParagraph(this.editparagraph)
      .then(paragraph => {
        this.$emit('save', paragraph)
        this.loading = false
        this.editHTML = false
      })
    }
  }
}
</script>

<style scoped>
  .adv_settings {
      padding:0 10px;
      padding: 0 25px 0 25px;
      border-top: 1px solid rgba(0,0,0,0.1)
  }
</style>
